import type { EmbeddedPlayerInfo } from '../../widget/src/interface';
import type { ActionsPaneStates, WebinarEditMode } from './context';

export enum PlayerPlacement {
  EWebinarPage,
  EmbeddedPlayer,
}

export enum PlayerMode {
  edit,
  replay,
  live,
}

export enum HasJoined {
  NotJoined,
  Joining,
  Joined,
}

export interface WebinarAreaDimensions {
  measured: boolean;
  width: number;
  height: number;
}

export interface VideoDimensions {
  measured: boolean;
  width: number;
  height: number;
  aspectRatio: number;
}

export interface VideoPlayerDimensionsOptions {
  isPlaying?: boolean;
  editMode?: WebinarEditMode;
  mode: PlayerMode;
  inTestMode: boolean;
  hasPinnedInteraction: boolean;
  borderRadius: number;
  actionsPaneState: ActionsPaneStates;
  focusedCardMode: boolean;
  isEmbeddedPlayer: boolean;
  isCollapsedEmbeddedPlayer: boolean;
  embeddedPlayerInfo: EmbeddedPlayerInfo;
  showAgenda: boolean;
  hasVideoPlayer: boolean;
  hasInteractions: boolean;
  hasChat: boolean;
  isEntireChatOff?: boolean;
}
